import { ConditionCode } from '@/shared/api/protocol-ts/model/dto_report_condition_codes_pb';

import { CHILD_CONDITION_GROUP_BY_CODE } from '../config';

export const splitConditionCodes = (codes: ConditionCode[] = []) =>
  codes.reduce(
    (acc, code) => {
      if (code in CHILD_CONDITION_GROUP_BY_CODE) {
        acc.childrenCodes.push(code);
      } else {
        acc.parentCodes.push(code);
      }

      return acc;
    },
    { parentCodes: [], childrenCodes: [] } as {
      parentCodes: ConditionCode[];
      childrenCodes: ConditionCode[];
    },
  );
